import React, { useState, useEffect } from "react";
import Cookies from "cookies-js"
import { styled } from "../../stitches.config";
import { bridVote } from './bridVote'
import { body, bodyLarge, h3, bodyStrong } from "../../redesign/commonStyles/Fonts";
import ArrowIcon from "../../assets/img/arrow-right-orange.svg"
import Media from "./Media";

const UniversalBridCompare = props => {
    const { article, secondArticleID, thirdArticleID, voted, uID, hasCookie } = props;
    const [percentage, setPercentage] = useState(null);
    const imageHeight = (props.imageHeight > 0 ? props.imageHeight : 328);
    const articlesGroup = [article.articleID, secondArticleID, thirdArticleID]

    useEffect(() => {
        const fetchVotes = () => {
            const fd = new FormData();

            fd.set("articlesGroup", JSON.stringify(articlesGroup));

            fetch(`${window.API_HOST}/pwa-brid-vote/`, {
                method: 'POST',
                body: fd
            })
                .then(response => {
                    return response.ok
                        ? response.json()
                        : Promise.reject(response.status);
                })
                .then(res => {
                    setPercentage(res.data.articlesAverage)
                })
                .catch(err => console.log(err))
        }

        fetchVotes()
    }, [])

    var imgUrl = article.picture.img;
    imgUrl = imgUrl.replace("780,0,0,0", "0," + imageHeight + ",0,0");
    return (
        <Container className="brid-universal-compare">
            <ImageWrapper>
                <Media src={imgUrl} />
            </ImageWrapper>
            <Article>
                <Title className={h3()}>{article.title}</Title>
                <Description className={body()}>{article.label}</Description>
                <ButtonsWrapper>
                    <Buttons className={bodyLarge}>
                        {hasCookie ?
                            <VoteButton disabled={true}>Dziękujemy!</VoteButton>
                            :
                            <VoteButton
                                disabled={!!(voted !== article.articleID ^ voted === null)}
                                onClick={() => {
                                    bridVote(article.articleID, articlesGroup)
                                    props.setVoted(article.articleID)
                                    if (uID) Cookies.set('_brid', `${props.uID}.${article.articleID}`, { expires: 86400 })
                                }}>
                                {voted === article.articleID ?
                                    "Dziękujemy!"
                                    :
                                    "Oddaj głos"
                                }
                            </VoteButton>
                        }
                        {article.link && <a href={article.link}><ReadMore>Dowiedz się więcej <Arrow /></ReadMore></a>}
                    </Buttons>
                    <Percentage className={bodyStrong()}>{percentage?.[article.articleID] ? percentage?.[article.articleID] : "0"}% {"oddanych "}głosów</Percentage>
                </ButtonsWrapper>
            </Article>
        </Container>
    );
}

const Container = styled("div", {
    display: "flex",
    flexDirection: "column",
    margin: "0px 12px 24px 12px",
    "@bp4": {
        flexDirection: "row",
    },
});

const ImageWrapper = styled("div", {
    flexShrink: 0,
    height: "214px",
    width: "100%",
    "@bp3": {
        height: "457px",
    },
    "@bp4": {
        height: "328px",
        width: "538px",
    }
});

const Article = styled("div", {
    width: "100%",
    position: "relative",
    "@bp4": {
        marginLeft: "48px",
        maxWidth: "625px",
        minHeight: "328px",
        display: "flex",
        flexDirection: "column",
    },
    "& a": {
        "&:hover": {
            textDecorationColor: "$primary"
        }
    }
});

const Title = styled("h3", {
    color: "$grayscale100",
    margin: "20px 0 12px 0",
    "@bp4": {
        margin: "0 0 12px 0",
    }
});

const Description = styled("p", {
    color: "$grayscale100",
    margin: 0,
    overflow: "hidden",
});

const Buttons = styled("div", {
    display: "flex",
    margin: "32px 0 10px 0",
});

const ButtonsWrapper = styled("div", {
    marginTop: "auto",
});

const ReadMore = styled("button", {
    background: "$grayscale0",
    padding: "11px 6px 13px 6px",
    color: "$primary",
    border: "none",
    outline: "none",
    marginLeft: "18px",
    display: "flex",
    alignItems: "center",
});

const Arrow = styled("span", {
    width: "13px",
    height: "10px",
    marginLeft: "6px",
    backgroundImage: `url("${ArrowIcon}")`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "block",
});

const VoteButton = styled("button", {
    background: "$primary",
    padding: "11px 0 13px 0",
    color: "$grayscale0Fixed",
    border: "none",
    outline: "none",
    width: "118px",
});

const Percentage = styled("p", {
    margin: 0,
    color: "$grayscale100",
});

export default UniversalBridCompare